// @core/api/endpoints/chat/create_conversation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ConversationResponse,
  CreateConversationRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Create a new conversation
 * Creates a new group or channel conversation with specified initial members and settings. For direct messages, use GetOrCreateDirectConversation instead.
 */
export async function CreateConversation(
  data: CreateConversationRequest,
  options?: RequestOptions
): Promise<ConversationResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/conversations`;
  const requestOptions = options;
  return client.post<ConversationResponse>(requestPath, data, requestOptions);
}
